
import React from 'react';

const ShowEditingCoorComponent = ({ isComponentChangeCoor, setIsComponentChangeCoor, handleSave }) => {
  const closeModal = () => {
    setIsComponentChangeCoor(false);
  };

  if (isComponentChangeCoor) {
    return (
      <div className="divRuler">
        <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Изменение положения</label>
        <hr className='horizontalLineModalUpTer' />
        <button className='buttonEditingLineSave2' style={{ marginRight: "5px" }} onClick={handleSave}>Сохранить</button>
        <button className='buttonEditingLineСancel' onClick={closeModal}>Закрыть</button>
      </div>
    );
  } else {
    return null;
  }
};

export default ShowEditingCoorComponent;